export default __webpack_public_path__ + "static/media/add_to_route.8d8f8c61.svg";